<template>
    <div class="numbers-block">
        <div class="numbers-block__head" v-if="canBuy">
            <div class="m-ui numbers-block__all">
                <input
                    class="sm"
                    :id="checkboxId"
                    type="checkbox"
                    data-element="number-block-checkbox"
                    :checked="allChecked"
                    :disabled="loading"
                    @change.prevent="toggleAll"
                />
                <label
                    :for="checkboxId"
                    @click.prevent="toggleAll"
                >Все</label>
            </div>
            Выбрано номеров: <span data-element="selected-num-cnt">{{ selectedCount }}</span>
        </div>
        <div class="numbers-block__ribbon">
            {{ displayCount }}
        </div>
        <NumberItem
            :item="item"
            :canBuy="canBuy"
            :canBuyMore="canBuyMore"
            :patterns="patterns"
            :key="item.id"
            v-for="item in items"
            @addNumber="(number) => addNumber(number)"
            @removeNumber="(number) => removeNumber(number)"
        />
        <Loader
            :hover="true"
            v-if="loading"
        />
    </div>
</template>

<script>
import NumberItem from './NumberItem'
import Loader from '../../../components/ui/Loader';
import utils from '../../../lib/utils';

export default {
    name: "NumbersBlock",
    components: {
        NumberItem,
        Loader
    },
    data() {
        return {
            id: Math.round(Math.random() * 1e6)
        }
    },
    props: {
        items: {
            type: Array
        },
        canBuy: {
            type: Boolean,
            default: true
        },
        canBuyMore: {
            type: Boolean,
            default: true
        },
        patterns: {
            type: Array
        },
        blockLoading: {
            type: Object
        }
    },
    computed: {
        checkboxId () {
            return 'checkbox_all_' + this.id
        },
        count () {
            return this.items.length
        },
        displayCount () {
            return utils.declOfNum(this.count, [
                'номер',
                'номера',
                'номеров'
            ], true)
        },
        selectedCount () {
            return this.items.filter(item => item.selected).length
        },
        allChecked () {
            return this.selectedCount === this.count
        },
        loading () {
            if (this.blockLoading) {
                return this.blockLoading[this.id] === true
            }
            return false
        }
    },
    methods: {
        addNumber (item) {
            if (this.loading) {
                return;
            }
            this.$emit('addNumbers', [item])
        },
        removeNumber (item) {
            if (this.loading) {
                return;
            }
            this.$emit('removeNumbers', [item])
        },
        toggleAll () {
            if (this.loading) {
                return;
            }
            let checked = !this.allChecked;
            let items = this.items.filter(item => item.selected !== checked);
            if (items.length === 0) {
                return;
            }
            if (checked) {
                this.$emit('addNumbers', items, this.id)
            } else {
                this.$emit('removeNumbers', items, this.id)
            }
        }
    }
}
</script>

<style scoped>

</style>